export default __webpack_public_path__ + "3492ac9153fe70a9a77ed08f1d65a9f0.png";